//npm run build::production
export const environment = Object.freeze({
    production: true,
    gateWayUrl: "https://gatewayapilearn.infinitylearn.com",
    commServiceUrl: "https://comservice.infinitylearn.com",
    semServiceUrl:
        "https://subjectiveevaluationmanagementv2.infinitylearn.com/",
    captchaSiteKey: "6LcLWcwrAAAAAMHP8O6cYf3uVpEjt3mtp4oBPZKb",
    ROLE_IDS: {
        EVALUATOR: 58,
    },
});